import { render, staticRenderFns } from "./netizenView.vue?vue&type=template&id=41743248&scoped=true"
import script from "./netizenView.vue?vue&type=script&lang=js"
export * from "./netizenView.vue?vue&type=script&lang=js"
import style0 from "./netizenView.vue?vue&type=style&index=0&id=41743248&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "41743248",
  null
  
)

export default component.exports